<nav class="navbar col-lg-12 col-12 p-0 d-flex flex-row">
  <div class="navbar-menu-wrapper d-flex" style="padding:0px;margin:0px;">
    <ul class="navbar-nav col-md-9">
      <li class="col-md-12">
        <div class="row">
          <div class="logo col-xs-2" style="width:80px;z-index:99;" *ngIf="!demo" (click)="toggleSidebar()" style="cursor:pointer;">
          <img [src]="logo_url" alt="" style="width:75px;height:75px;">
          </div>
          <div class="col-md-10 p-l-10 p-t-35" *ngIf="!demo">
            <h5 class="title text-white font-weight-bold">{{title}}</h5>
            <div style="height:7px;"></div>
            <h5 class="title text-white font-weight-bold">{{defConf.org_name}}</h5>
          </div>
          <div class="col-md-10 p-l-10 p-t-2" *ngIf="demo">
            <h4 class="title text-white font-weight-bold">ภาษีที่ดินและสิ่งปลูกสร้าง :: {{defConf.org_name}}</h4>
          </div>
        </div>

      </li>
    </ul>
    <ul class="navbar-nav navbar-nav-right col-md-3  align-items-right justify-content-end">
      <li class="p-l-10 p-t-10 title font-weight-bold text-gray-dark" style="margin-top:10px;">
        <h5>เข้าสู่ระบบโดย :: {{current.first_name}} {{current.last_name}}</h5>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
      (click)="toggleRightSidebar()">
      <span class="ti-layout-grid2"></span>
    </button>
  </div>
</nav>